import { Link } from 'react-router-dom';

const YEAR = new Date().getFullYear();

const LINKS = [
  { to: '/', label: 'resstro.ru' },
  { to: '/downloads', label: 'Загрузки' },
  { to: '/support', label: 'Поддержка' },
  { to: '/legal/offer', label: 'Оферта' },
  { to: '/legal/privacy', label: 'Конфиденциальность' },
];

export default function DocsFooter() {
  return (
    <footer className="border-t border-ink/[0.08]">
      <div className="mx-auto flex max-w-[90rem] flex-col gap-3 px-5 py-7 text-[13.5px] text-ink/60 sm:flex-row sm:items-center sm:justify-between sm:px-8">
        {/* Год считается при пререндере; до пересборки после Нового года он отличается от клиентского. */}
        <span suppressHydrationWarning>© {YEAR} Resstro</span>
        <nav aria-label="Ссылки сайта" className="flex flex-wrap gap-x-5 gap-y-2">
          {LINKS.map((link) => (
            <Link key={link.to} to={link.to} className="transition-colors hover:text-ink">
              {link.label}
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  );
}
